import { render, staticRenderFns } from "./ReActionInput.vue?vue&type=template&id=2fff04f2"
import script from "./ReActionInput.vue?vue&type=script&lang=js"
export * from "./ReActionInput.vue?vue&type=script&lang=js"
import style0 from "./ReActionInput.vue?vue&type=style&index=0&id=2fff04f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports